var map = {
	"./amex.svg": 963,
	"./diner.svg": 964,
	"./discover.svg": 965,
	"./gpay.svg": 966,
	"./maestro.svg": 967,
	"./mastercard.svg": 968,
	"./padlock.svg": 484,
	"./shop.svg": 969,
	"./union.svg": 970,
	"./visa.svg": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 962;